export const FREE_TIER = "Starter";

export const SEAT_TIER = "Studio";

export const EXPORT_TIER = "Enterprise";

export const PRODUCTION_FACILITY = "VARIANT3D's facility";

export const MACHINE_EXPORT_LABEL = `Machine file export — ${SEAT_TIER} and up`;

export const DEDICATED_SUPPORT_LABEL = `Dedicated customer support — ${EXPORT_TIER}`;
